@let top = windowScrollTopPosition$ | async;
@if (top > this.treshhold()) {
    <bazis-button
        part="button"
        [size]="sizeBtn()"
        (click)="scrollToTop()"
    >
        <bazis-icon
            part="icon"
            slot="icon-only"
            [size]="sizeIcon()"
            [icon]="icon()"
        ></bazis-icon>
    </bazis-button>
}
